import { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import { toast} from 'react-toastify';
import { listGroup, deleteContact, contactStatus } from '../../../Context/api';
import { statusCodes, commonMessage } from '../../../Constants/generalConfig';

const UseGroup = () => {

    const [groupsList, setGroupsList] = useState([])
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const [spinner, setSpinner] = useState(false)
    const navigate = useNavigate()
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const [deleteShow, setDeleteShow] = useState({ open: false, data: '' })

    useEffect(() => {
        list()
    }, [page])

    const list = () => {
        setSpinner(true)
        axios.post(listGroup(), { type: "ADMIN", count: PER_PAGE, page: page, }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setGroupsList(resp.data)
                setCount(resp?.data?.totalCount)
                setSpinner(false)
            }
            else {
                setGroupsList([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const statusChange = (item) => {
        setSpinner(true)
        axios.post(contactStatus(), { id: item._id, isActive: !item.isActive }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    const contactDelete = () => {
        setSpinner(true)
        axios.post(deleteContact(), { id: deleteShow?.data?._id }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
                setDeleteShow({ open: false, data: '' })
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)
            }
        })
    }
  return {
    contactDelete,
    statusChange,
    setPage,
    navigate,
    setDeleteShow,
    deleteShow,
    PER_PAGE,
    count,
    page,
    spinner,
    groupsList,


  }
}

export default UseGroup